import { Component } from "react";
// import { withRouter } from "react-router-dom";
import SocieteService from "../../services/SocieteService";
import Select from "react-select";
import ErrorAlert from "../constantPages/Alerts/ErrorAlert";
import makeAnimated from "react-select/animated";
import Societe from "../../services/Societe";
import { Navigate } from "react-router-dom";
// this class is used to choose which supplier(fournisseur) will add the Bon de commande
//the respose will be in the class AddBCAchat

export default class AddBCListSociete extends Component {

  constructor(props) {
    super(props);
    this.state = {
      alert_message: "",
      idSociete: "",
      redirect: false,

      societes: [],
      options: [],
    };
  }
  componentDidMount() {
    this.forceUpdate();

    Societe.getSocietesClients(
      this.props.typeSociete,
      this.props.typeClient,
      1,
      0
    )
      .then((response) => {
        console.log("response", response)
        if (response.data["Societe"] === "erreur") {
          this.setState({ alert_message: "error" });
        } else {
          this.setState({ societes: response.data["Societe"] });
          console.log("Societe", this.state.societes);
          this.setState({ alert_message: "success" });
          this.remplissageOptions();
        }
      })
      .catch((error) => {
        this.setState({ alert_message: "error" });
      });
  }
  remplissageOptions() {

    this.state.societes.map((typeBill) => {
      if (typeBill !== null) {
        this.setState({
          options: [
            ...this.state.options,
            { value: typeBill.id, label: typeBill.title },
          ],
        })
      }
    }

    );
  }
  handleChange = (selectedOption) => {
    this.setState({ selectedOption }, () =>
      console.log(`Option selected:`, this.state.selectedOption)
    );
    this.setState({ idSociete: selectedOption.value });
    console.log("idSociete", this.state.idSociete);
  };

  saveIdSociete = (e) => {
    console.log(this.state.idSociete);

    localStorage.setItem("idSociete", this.state.idSociete);

    if (this.state.idSociete === "") {
      this.setState({ alert_message: "error choice" });
    } else {
      localStorage.setItem("idSociete", this.state.idSociete);
      console.log("idSociete", localStorage.getItem("idSociete"));
      setTimeout(() => {
        this.setState({ redirect: true });
      }, 0);
      // this.props.history.push("/addBCAchat");
    }

    e.preventDefault();
  };

  render() {
    const animatedComponents = makeAnimated();
    if (this.state.redirect) {
      return <Navigate replace to="/addBCAchat" />;
    } else {
      if (this.props.typeClient === "CLIENT") {
        if (this.state.alert_message === "error") {
          return (
            <div className="content-wrapper">
              <section class="content">
                <div class="row">
                  <div class="col-md-12">
                    <ErrorAlert message="Désolé aucun Société cliente à afficher, Vous devez ajouter une société svp" />
                  </div>
                </div>
              </section>
            </div>
          );
        } else if (this.state.alert_message === "error choice") {
          return (
            <div className="content-wrapper">
              <section class="content">
                <div class="row">
                  <div class="col-md-12">
                    <ErrorAlert message="Vous devez choisir un des clients de la liste" />
                  </div>
                </div>

                <div class="card ">
                  <div class="card-header">
                    <h3 class="card-title">Liste des clients</h3>
                  </div>
                  <form
                    className="form-horizontal"
                    onSubmit={this.saveIdSociete}
                  ></form>
                  {/* /.box-header */}
                  <div className="card-body">
                    <div class="form-group">
                      <Select
                        value={this.state.selectedOption}
                        closeMenuOnSelect={true}
                        components={animatedComponents}
                        options={this.state.options}
                        onChange={this.handleChange}
                      />
                    </div>
                  </div>
                  <div className="box-footer">
                    {/* <Link to="/addFraisInscrit" > */}
                    <button
                      type="submit"
                      onClick={this.saveIdSociete}
                      className="btn btn-info "
                    >
                      Valider
                    </button>
                    {/* </Link> */}
                  </div>
                </div>
              </section>
            </div>
          );
        } else {
          return (
            <div className="content-wrapper">
              <section class="content">
                <div class="row">
                  <div class="col-md-12">
                    <div class="card ">
                      <div class="card-header">
                        <h3 class="card-title">Liste des clients</h3>
                      </div>
                      <form
                        className="form-horizontal"
                        onSubmit={this.saveIdTypeBill}
                      ></form>
                      {/* /.box-header */}
                      <div className="card-body">
                        <div class="form-group">
                          <Select
                            value={this.state.selectedOption}
                            closeMenuOnSelect={true}
                            components={animatedComponents}
                            options={this.state.options}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                      <div className="card-footer">
                        <button
                          type="submit"
                          onClick={this.saveIdSociete}
                          className="btn btn-info float-right"
                        >
                          Valider
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          );
        }
      } else {
        if (this.state.alert_message === "error") {
          return (
            <div className="content-wrapper">
              <section class="content">
                <div class="row">
                  <div class="col-md-12">
                    <ErrorAlert message="Désolé aucun Société Fournisseurs à afficher, Vous devez ajouter une société svp" />
                  </div>
                </div>
              </section>
            </div>
          );
        } else if (this.state.alert_message === "error choice") {
          return (
            <div className="content-wrapper">
              <section class="content">
                <div class="row">
                  <div class="col-md-12">
                    <ErrorAlert message="Vous devez choisir un des fournisseurs de la liste" />
                  </div>
                </div>

                <div class="card ">
                  <div class="card-header">
                    <h3 class="card-title">Liste des Fournisseurs</h3>
                  </div>
                  <form
                    className="form-horizontal"
                    onSubmit={this.saveIdSociete}
                  ></form>

                  <div className="card-body">
                    <div class="form-group">
                      <Select
                        value={this.state.selectedOption}
                        closeMenuOnSelect={true}
                        components={animatedComponents}
                        options={this.state.options}
                        onChange={this.handleChange}
                      />
                    </div>
                  </div>

                  <div className="card-footer">
                    <button
                      type="submit"
                      onClick={this.saveIdSociete}
                      className="btn btn-info float-right"
                    >
                      Valider
                    </button>
                    {/* </Link> */}
                  </div>
                </div>
              </section>
            </div>
          );
        } else {
          return (
            <div className="content-wrapper" style={{ marginTop: "0" }}>
              <section className="content-header">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-md-6"></div>
                    <div className="col-md-6">
                      <ol class="breadcrumb float-sm-right">
                        <li class="breadcrumb-item">Home</li>
                        <li class="breadcrumb-item active">Ajouter Bon de commande</li>
                      </ol>
                    </div>
                  </div>
                </div>
              </section>
              <section class="content">
                <div class="row">
                  <div class="col-md-12">
                    <div class="card card-dark">
                      <div class="card-header">
                        <h3 class="card-title">Liste des Fournisseurs</h3>
                      </div>
                      <form
                        className="form-horizontal"
                        onSubmit={this.saveIdSociete}
                      ></form>

                      <div className="card-body">
                        <div class="form-group">
                          <Select
                            value={this.state.selectedOption}
                            closeMenuOnSelect={true}
                            components={animatedComponents}
                            options={this.state.options}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>

                      <div className="card-footer">
                        <div className="col-sm-12  text-center">

                          <button
                            type="submit"
                            onClick={this.saveIdSociete}
                            className="btn btn-dark"
                          >
                            Valider
                          </button>
                        </div>
                        {/* </Link> */}
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          );
        }
      }
    }
  }
}

